import { useEffect, useRef } from 'react';

import useAnimate from '@Hotels-at-Home/hah-fe-core/dist/hooks/useAnimate';
import Services from '~/ui/components/common/Services';
import { homeServicesMock } from '~/ui/components/common/Services/servicesMock';
import { IGetPromotionResponse } from '@Hotels-at-Home/hah-fe-core/dist/types';
import { getYmal } from '@Hotels-at-Home/hah-fe-core/dist/store/ymal/thunks';
import { useDispatch } from '~/store/hooks';
import { useRouter } from 'next/router';
import { useShowError } from '@Hotels-at-Home/hah-fe-core/dist/hooks';
import HeroSection from './sections/HeroSection';
import BedSection from './sections/BedSection';
import BeddingSection from './sections/BeddingSection';
import BathTowelsRobesSection from './sections/BathTowelsRobesSection';
import BathBodySection from './sections/BathBodySection';
import FragranceSection from './sections/FragranceSection';
import EarnAndBurnSection from './sections/EarnAndBurnSection';
import GuestFavouritesSection from './sections/GuestFavouritesSection';

interface IProps {
  promotion: IGetPromotionResponse;
}

const Home = ({ promotion }: IProps) => {
  const animateRef = useRef(null);
  const dispatch = useDispatch();
  const { locale } = useRouter();
  const showError = useShowError();

  useAnimate(animateRef);

  // fetch YMALS for HP

  const fetchYmal = async () => {
    const ymalResult = await dispatch(getYmal());

    if (getYmal.rejected.match(ymalResult)) {
      showError(ymalResult.payload.errorMessage);
    }
  };

  useEffect(() => {
    fetchYmal();
  }, [locale]);
  return (
    <div id="home" ref={animateRef}>
      <HeroSection promotion={promotion} />
      <div className="hp-content-wrapper">
        <GuestFavouritesSection />
        <BedSection />
        <BeddingSection />
        <BathTowelsRobesSection />
        <BathBodySection />
        <FragranceSection />
        <EarnAndBurnSection />
        <Services items={homeServicesMock} mainSection />
      </div>
    </div>
  );
};

export default Home;
